import { useEffect } from 'react'

import useSession from 'hooks/useSession'
import useFeatureSwitch from 'hooks/useFeatureSwitch'

import { CountryCode } from 'constants/country'
import useCookie from '_libs/common/cookie-manager/hooks/useCookie'
import { cookiesDataByName } from '_libs/common/cookie-manager/cookies-data'

const MAX_VISITS_FOR_PROMO = 5
const COUNTRIES_FOR_NO_PROMO = [CountryCode.Lt, CountryCode.De, CountryCode.At]

export const useSellerPromotion = (visitsCount: number) => {
  const { user } = useSession()
  const isPortalMergeSourceEnabled = useFeatureSwitch('portal_merge_source')
  const cookie = useCookie()

  const countryCodeLowerCase = (user?.country_code || '') as CountryCode
  const isNoPromoCountry = COUNTRIES_FOR_NO_PROMO.includes(countryCodeLowerCase)
  const isPromotionDisabled = isNoPromoCountry || isPortalMergeSourceEnabled
  const isAnonymous = !user
  const isUserEligibleForPromotion = user && !user.item_count && visitsCount <= MAX_VISITS_FOR_PROMO

  const showSellerPromotion = !isPromotionDisabled && (isAnonymous || isUserEligibleForPromotion)

  useEffect(() => {
    if (!user) return
    if (!showSellerPromotion) return

    cookie.set(cookiesDataByName.seller_header_visits, String(visitsCount + 1))
  }, [user, visitsCount, showSellerPromotion, cookie])

  return {
    showSellerPromotion,
  }
}
